import { useCallback, useMemo } from 'react';
import { ApolloCache, FetchResult } from '@apollo/client';
import {
  AnalyticsMetaDataDocument,
  PutAnalyticsMetadataInput,
  PutAnalyticsMetaDataMutation,
  usePutAnalyticsMetaDataMutation
} from 'graphql/types';

export const usePutAnalyticsMetaData = (): {
  putAnalyticsMetaData: (
    input: PutAnalyticsMetadataInput
  ) => Promise<
    FetchResult<
      PutAnalyticsMetaDataMutation,
      Record<string, any>,
      Record<string, any>
    >
  >;
  loading: boolean;
} => {
  const [
    PutAnalyticsMetaDataMutation,
    { loading }
  ] = usePutAnalyticsMetaDataMutation();

  const putAnalyticsMetaData = useCallback(
    async (input: PutAnalyticsMetadataInput) =>
      await PutAnalyticsMetaDataMutation({
        variables: {
          input
        },
        update(cache: ApolloCache<PutAnalyticsMetaDataMutation>) {
          cache.writeQuery({
            query: AnalyticsMetaDataDocument,
            variables: { input: { type: input.type } },
            data: {
              analyticsMetadata: {
                metadata: input?.metadata
              }
            }
          });
        }
      }),

    [PutAnalyticsMetaDataMutation]
  );

  return useMemo(
    () => ({
      putAnalyticsMetaData,
      loading
    }),
    [putAnalyticsMetaData, loading]
  );
};
